export const title = 'Média de aberturas';

Quantidade média de aberturas por campanha. Uma abertura acontece quando um usuário abre a notificação que recebeu.
